import { Stack, Typography } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

import { SubmissionLogTab } from '../../components';

type SubmissionLogSearch = {
  advisoryOrganizationId?: string;
  jobStatus?: string;
  planId?: string;
  queueDateTimeFrom?: string;
  queueDateTimeTo?: string;
};

const asString = (value: unknown) =>
  typeof value === 'string' ? value : undefined;

const SubmissionLogPage = () => (
  <Stack spacing={2} sx={{ height: '100%', p: 2 }}>
    <Typography variant='h5'>Submission Log</Typography>
    <SubmissionLogTab mode='global' />
  </Stack>
);

export const Route = createFileRoute('/submission-log/')({
  component: SubmissionLogPage,
  validateSearch: (search: Record<string, unknown>): SubmissionLogSearch => ({
    advisoryOrganizationId: asString(search.advisoryOrganizationId),
    jobStatus: asString(search.jobStatus),
    planId: asString(search.planId),
    queueDateTimeFrom: asString(search.queueDateTimeFrom),
    queueDateTimeTo: asString(search.queueDateTimeTo)
  })
});
